import { useContext } from 'react';
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { registrationsContext } from '../RegistrationsContext';
import { FilterContainer, SearchButton } from 'components';


let Filters = () => {
    let service = useContext(registrationsContext);


    return (
        <FilterContainer onSubmit={() => service.doSearch()}>
            <Grid item xs>
                <TextField
                    variant="outlined"
                    label="Product Code"
                    value={service.search.sku}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        sku: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <TextField
                    variant="outlined"
                    label="Firstname"
                    value={service.search.firstName}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        firstName: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <TextField
                    variant="outlined"
                    label="Lastname"
                    value={service.search.lastName}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        lastName: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <TextField
                    variant="outlined"
                    label="Email"
                    value={service.search.email}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        email: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <TextField
                    variant="outlined"
                    label="Claim number"
                    value={service.search.claimNumber}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        claimNumber: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <TextField
                    select
                    label="Show only"
                    variant="outlined"
                    value={service.search.isDeleted}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        isDeleted: e.target.value === 'true'
                    })}
                >
                    <MenuItem value='false'>Active Registrations</MenuItem>
                    <MenuItem value='true'>Deleted Registrations</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs>
                <SearchButton type="submit" />
            </Grid>
        </FilterContainer>
    )
}

export default Filters;